// Filename: /src/components/CommentSection/LoginPrompt.js

import React from 'react';
import { Link } from 'react-router-dom';
import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/24/outline';

const LoginPrompt = () => {
  return (
    <div className="text-center p-4 bg-gray-900/50 border border-gray-800 rounded-lg">
      <ChatBubbleBottomCenterTextIcon className="w-8 h-8 mx-auto mb-2 text-gray-500" />
      <p className="text-gray-300 font-semibold">Want to join the conversation?</p>
      <p className="text-gray-400 text-sm mt-1">
        <Link to="/signup" className="text-indigo-400 hover:text-indigo-300 font-bold underline">Create an account</Link> or{' '}
        <Link to="/login" className="text-indigo-400 hover:text-indigo-300 font-bold underline">log in</Link> to share your thoughts.
      </p>
    </div>
  );
};

export default LoginPrompt;